import { useActiveProject } from '@nx/state';
import { ErrorBanner } from '@nx/ui/src/errors/error-banner/error-banner';

const ProjectIncapableFallback = () => {
  return (
    <div className="mt-4 sm:mx-4 md:mx-8 xl:mx-auto xl:max-w-[1680px] xl:px-8">
      <ErrorBanner title={'Project is incapable of Self-managed deployments monitoring.'} />
    </div>
  );
};

const withProjectCapabilityGuard =
  (WrappedComponent: () => React.JSX.Element) =>
  // eslint-disable-next-line react/display-name
  () => {
    const activeProject = useActiveProject();

    return activeProject.capabilities.fleet_management ? <WrappedComponent /> : <ProjectIncapableFallback />;
  };

export default withProjectCapabilityGuard;
